
export class ScreeningStandardparameters {
    public infiltration: number;
    public aquiferDepth: number;
    public headGradient: number;
    public lithoCode: number;

    public distNearestWaterWell: number;
    public distNoClay: number;
    public porosity: number;
    public horizontalHydraulicConductivity: number;
    public firstOrderDegradationRate: number;
}
